<div class="flex flex-col space-y-2">
    @if (viewModel(); as vm) {
    <app-validated-number-input [control]="getControl('surfaceAmbientTemperature')"
        [value]="vm.data.surfaceAmbientTemperature" [validation]="vm.validation.surfaceAmbientTemperature"
        id="surfaceTemp" [label]="`Surface Temperature @ 0 ${depthUnit} RKB`" [unit]="tempUnit" />

    @if (vm.data.mudlineTemperature !== undefined && vm.validation.mudlineTemperature) {
    <app-validated-number-input [control]="getControl('mudlineTemperature')" [value]="vm.data.mudlineTemperature"
        [validation]="vm.validation.mudlineTemperature" id="mudlineTemp" [label]="mudlineDepth != null ? `Mudline Temperature @ ${mudlineDepth.toFixed(2)} ${depthUnit} TVD` : 'Mudline Temperature'"
        [unit]="tempUnit" />
    }

    <app-validated-number-input [control]="getControl('temperatureGradient')" [value]="vm.data.temperatureGradient"
        [validation]="vm.validation.temperatureGradient" id="tempGradient" label="Gradient"
        [unit]="gradientUnit" />

    <app-validated-number-input [control]="getControl('temperatureAtTd')" [value]="vm.data.temperatureAtTd"
        [validation]="vm.validation.temperatureAtTd" id="tempAtTd" [label]="`TD Temperature @ ${totalDepth.toFixed(2)} ${depthUnit} TVD`"
        [unit]="tempUnit" />
    }
</div>